// src/api.js — tiny fetch wrapper for the RESET API (cookie auth, JSON).

export const API_BASE =
  typeof process.env.REACT_APP_API_BASE_URL === "string"
    ? process.env.REACT_APP_API_BASE_URL
    : "http://localhost:3001";

async function request(method, path, body) {
  const opts = { method, credentials: "include", headers: {} };
  if (body !== undefined) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${API_BASE}${path}`, opts);
  let json = null;
  try {
    json = await res.json();
  } catch (_) {
    json = null;
  }
  if (!res.ok) {
    const err = new Error((json && (json.error || json.message)) || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = json;
    throw err;
  }
  return json;
}

export const api = {
  get: (path) => request("GET", path),
  post: (path, body = {}) => request("POST", path, body),
  patch: (path, body = {}) => request("PATCH", path, body),
  del: (path) => request("DELETE", path),
};

/** Redirect the browser into a server-side OAuth start route. */
export function startOAuth(path) {
  window.location.href = `${API_BASE}${path}`;
}

export default api;
